import { useRoleContext } from "hooks/useRoleContext";

import { useSwrFetch } from "./useSwrFetch";

import type { InboundNetworkInvite } from "../components/SupplierNetwork/types";

interface UseInboundNetworkInvitesReturn {
  data: InboundNetworkInvite[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useInboundNetworkInvites(): UseInboundNetworkInvitesReturn {
  const { role } = useRoleContext();

  if (role && role.type !== "SHIPPER") {
    throw new Error(
      "useInboundNetworkInvites can only be used by shipper users",
    );
  }

  const url = role
    ? `/shippers/${role.id}/network-invites/inbound-pending`
    : null;

  const { data, loading, error, refetch } = useSwrFetch<InboundNetworkInvite[]>(
    {
      url,
      errorMessage: "Failed to fetch inbound network invites",
    },
  );

  return {
    data: data ?? [],
    loading,
    error,
    refetch,
  };
}
